
import React from 'react'
import { getData } from 'country-list'
import { useTranslation } from 'react-i18next'
import SelectField from './SelectField'

const CountrySelect = props => {
    const { t } = useTranslation()
    const countries = getData()

    // Ordenar países por nombre traducido
    const sortedCountries = [...countries].sort((a, b) => {
        const nameA = t(`countries.${a.code}`) || a.name
        const nameB = t(`countries.${b.code}`) || b.name
        return nameA.localeCompare(nameB)
    })

    return (
        <SelectField
            {...props}
        >
            {sortedCountries.map(item => (
                <option key={item.code} value={item.code}>
                    {t(`countries.${item.code}`) || item.name}
                </option>
            ))}
        </SelectField>
    )
}

export default CountrySelect

